import { render, staticRenderFns } from "./TicketStatistics.vue?vue&type=template&id=754a1ac1&"
import script from "./TicketStatistics.vue?vue&type=script&lang=js&"
export * from "./TicketStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports